module.exports = __webpack_public_path__ + "static/media/retrato_7.3d788867.jpg";